module.exports = __webpack_public_path__ + "static/media/fa-brands-400.56c8d808.ttf";